/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 読み取り権限のみ付与されている内容タグをレスポンスに含めるかどうかを判断するためのフラグ - INCLUDE:含む(読み取り権限があるものと書き込み権限があるもの両方を返却する) - EXCLUDE:含まない(書き込み権限があるものに絞る) 
 * @export
 * @enum {string}
 */

export const IncludeReadOnlyQuery = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE'
} as const;

export type IncludeReadOnlyQuery = typeof IncludeReadOnlyQuery[keyof typeof IncludeReadOnlyQuery];



